import { render, staticRenderFns } from "./CbsObjectView.vue?vue&type=template&id=dae8cbfe&scoped=true"
import script from "./CbsObjectView.vue?vue&type=script&lang=js"
export * from "./CbsObjectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae8cbfe",
  null
  
)

export default component.exports